import React from 'react'
import TabsProvider from '../tabs-provider'

const ShowCourse = ({ params: { courseId }, location, children }) => (
  <div>
    <TabsProvider
      pathname={location.pathname}
      tabs={[{
        label: 'Edit Course',
        path: `/events/courses/${courseId}/edit`
      }, {
        label: 'Webinars',
        path: `/events/courses/${courseId}/webinars`
      }]}
    />
    {children}
  </div>
)

export default ShowCourse
